import React from "react";
import CssClasses from "./SystemCombinationsPopup.css";
//import SiteIcons from "../../assets/fonts/site_icons/style.css";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
//import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";

const SystemCombinationsPopup = props => {
  //let dummyMatches = [];
  //let dummySystems = [];

  //sortni ih po fixu pa po legendi
  var pairs = [...props.ticketPairInfo];
  var checkedSystems = [...props.systemCombinations];
  checkedSystems = checkedSystems.filter(x => x.isChecked);

  var systemsToDisplay = [];
  let idCtr = 0;

  //idi po svakom cekiranom i guraj u ovo
  for (let i = 0; i < checkedSystems.length; i++) {
    const sys = checkedSystems[i];

    //idi po svakom
    for (let j = 0; j < sys.combinationList.length; j++) {
      idCtr++;
      const comb = sys.combinationList[j];

      systemsToDisplay.push({
        id: idCtr,
        title: comb.combination,
        value: comb.possibleWin * 0.01
      });
    }
  }

  //makni neaktivne parove
  pairs = pairs.filter(x => x.checked);

  //sortiraj parove
  pairs.sort((a, b) => {
    if (a.isFix) {
      return -1;
    }

    if (b.isFix) {
      return 1;
    }

    if (a.systemLegend > b.systemLegend) {
      return 1;
    } else {
      return -1;
    }
  });

  return (
    <div className={CssClasses.container}>
      <div className={CssClasses.popupBox}>
        <div className={CssClasses.combinationsBox}>
          {/* <div
            className={CssClasses.closeBtn}
            onClick={() => btnClosePopup_Click(props)}
          >
            <span
              className={[
                SiteIcons.site_icon_close_thin
                //,CssClasses.fadingAnim
              ].join(" ")}
            />
          </div> */}
          <div className={CssClasses.titleRow}>Popis kombinacija</div>

          <div className={CssClasses.scrollableSection}>
            {/* stvori ih u petlji */}
            {systemsToDisplay.map(system => {
              return (
                <div className={CssClasses.systemBox} key={system.id}>
                  <span className={CssClasses.systemLegend}>
                    {system.title}:{" "}
                  </span>
                  {system.value.toFixed(2)}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    currentOddFormat: state.rrAppState.oddFormatID,
    systemCombinations: state.rrTicket.systemCombinations
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setIsShowingSystemCombinationsPopup: isShowing =>
      dispatch(StoreActions.SetIsShowingSystemCombinationsPopup(isShowing))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SystemCombinationsPopup);



// WEBPACK FOOTER //
// ./src/Components/SystemCombinationsPopup/SystemCombinationsPopup.js